import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { Header } from "@/components/Header";
import { Icon } from "@/components/Icon";
import { Text } from "@/components/Text";
import { Flex, Tooltip } from "@/eworkitComponents";

interface IEmailNotificationSettingsGroupProps {
  header: string;
  frequencyTooltipText?: string;
}

export const EmailNotificationSettingsGroup: FC<IEmailNotificationSettingsGroupProps> = ({
  header,
  frequencyTooltipText,
  children,
}) => {
  const { t } = useTranslation("session");

  return (
    <div>
      <Flex width={12} direction="row">
        <Flex grow={1}>
          <Header size="sm" color="black" weight="bold">
            {header}
          </Header>
        </Flex>

        {frequencyTooltipText && (
          <Flex width={3} direction="row" innerMargin="xs" justify="flex-end">
            <Text color="grey1">{t("USERS.SETTINGS.EMAIL_NOTIFICATIONS.FREQUENCY")}</Text>
            <Tooltip content={frequencyTooltipText} placement="top">
              <Flex justify="center">
                <Icon icon="info" color="grey3" size="md" />
              </Flex>
            </Tooltip>
          </Flex>
        )}
      </Flex>

      <Flex
        direction="column"
        innerBorder
        innerPadding="sm"
        border={[true, false, false]}
        padding={["sm", false]}
        margin={["sm", false, false, false]}>
        {children}
      </Flex>
    </div>
  );
};
